import { Hero } from "../hero/hero";

export const Mainpage = () => {
  return (
    <div>
      <Hero />
    </div>
  );
};
